/**
 * Shared motion tokens for the learner portal (Phase SC-13).
 * Emil standard — Iron Rule #6: ease-out enters, GPU-only, reduced-motion safe.
 */
export const EASE_OUT: [number, number, number, number] = [0.23, 1, 0.32, 1];

export const FLOW_ENTER = {
  duration: 0.24,
  ease: EASE_OUT,
} as const;

export const RESULT_ENTER = {
  duration: 0.32,
  ease: EASE_OUT,
} as const;

export const STAGGER_S = 0.06;
